"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _index = require("@/api/goods/index");

var _baidu_tts_cors = _interopRequireDefault(require("@/utils/baidu_tts_cors"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Prodetail',
  data: function data() {
    return {
      profile: {
        goods: {
          description: ''
        }
      },
      audio: '',
      canPlay: true
    };
  },
  components: {},
  methods: {
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _index.getProfileDetail)(this.$route.query.profile_id).then(function (res) {
                  _this.profile = res.data;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }(),
    play: function play() {
      if (this.audio) {
        if (this.canPlay) {
          this.canPlay = false;
          this.audio.play();
        } else {
          this.canPlay = true;
          this.audio.pause();
        }
      }
    },
    reset: function reset() {},
    tts: function () {
      var _tts = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var obj;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                obj = this; // 调用语音合成接口
                // 参数含义请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6

                (0, _baidu_tts_cors.default)({
                  tex: this.delHtmlTag(this.profile.goods.description),
                  spd: 6
                  /* pit: 5,
                     vol: 15,
                     per: 4 */

                }, {
                  //  volume: 0.3,
                  autoplay: true,
                  autoDestory: true,
                  timeout: 10000,
                  hidden: false,
                  onInit: function onInit(htmlAudioElement) {},
                  onSuccess: function onSuccess(htmlAudioElement) {
                    obj.audio = htmlAudioElement;
                    obj.audio.pause();
                  },
                  onError: function onError(text) {},
                  onTimeout: function onTimeout() {},
                  oneended: function oneended() {}
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function tts() {
        return _tts.apply(this, arguments);
      }

      return tts;
    }()
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.initData();

            case 2:
              _context3.next = 4;
              return this.tts();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  destroyed: function destroyed() {
    this.audio.pause();
    this.$set(this, 'audio', '');
  }
};
exports.default = _default;